module.exports = __webpack_public_path__ + "img/register-bg.15427303.png";